var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWork4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5 51.1069V86.4896",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.249 87.8165L50.1915 77.6773C52.4321 75.3924 55.2489 73.4618 58.481 71.996C61.7132 70.5301 65.2975 69.5576 69.0292 69.134C72.7609 68.7103 76.567 68.8439 80.2301 69.527C83.8933 70.2101 87.3417 71.4294 90.3786 73.1152L80.4051 83.286C75.88 87.9007 69.1039 90.9738 61.5673 91.8293C54.0308 92.6849 46.3512 91.2528 40.218 87.8481L40.249 87.8165Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29871 66.9326C11.0567 64.8465 15.7622 63.969 20.38 64.4932C24.9979 65.0174 29.1498 66.9004 31.9224 69.728L38.0182 75.9443C34.2857 78.0166 29.6173 78.897 25.027 78.3943C20.4368 77.8916 16.2956 76.0465 13.503 73.2597L7.29871 66.9326Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 26.823C67 23.8506 65.733 21.0001 63.4777 18.8983C61.2223 16.7966 58.1635 15.6158 54.974 15.6158C53.8154 15.6445 52.6682 15.8372 51.5718 16.1872C51.5718 13.2198 50.3069 10.3739 48.0553 8.27563C45.8037 6.17734 42.7498 4.99854 39.5656 4.99854C36.3813 4.99854 33.3275 6.17734 31.0759 8.27563C28.8243 10.3739 27.5593 13.2198 27.5593 16.1872C26.3822 15.8382 25.1551 15.6579 23.9199 15.6527C21.0862 15.6717 18.3511 16.6241 16.1984 18.3415C14.0457 20.0588 12.6142 22.4304 12.1572 25.0366C11.7002 27.6428 12.2471 30.3156 13.7011 32.5822C15.1551 34.8489 17.4226 36.5631 20.1024 37.4218C18.3023 39.834 17.5927 42.8093 18.1267 45.705C18.6608 48.6007 20.3957 51.1845 22.9567 52.8982C25.5177 54.6119 28.6993 55.3181 31.8143 54.8642C34.9293 54.4103 37.7277 52.8327 39.6051 50.4722C41.1239 52.3422 43.2347 53.7202 45.6395 54.4114C48.0442 55.1027 50.6213 55.0724 53.0065 54.3246C55.3917 53.5769 57.4645 52.1496 58.932 50.2445C60.3996 48.3393 61.1876 46.0526 61.1848 43.7074C61.1912 41.4334 60.4453 39.2128 59.0486 37.3481C61.3739 36.5677 63.3847 35.1387 64.8074 33.2554C66.2302 31.3722 66.9958 29.1261 67 26.823Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 39.9985C45.5228 39.9985 50 35.5214 50 29.9985C50 24.4757 45.5228 19.9985 40 19.9985C34.4772 19.9985 30 24.4757 30 29.9985C30 35.5214 34.4772 39.9985 40 39.9985Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_67"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    fill: "white",
    transform: "translate(0 -0.00146484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork4);
export default __webpack_public_path__ + "static/media/work4.08156f982fec29e6c145b06ca6f40daf.svg";
export { ForwardRef as ReactComponent };